/**
 * MSAL config. Only used when env.MOCK_AUTH is false.
 *
 * Local dev defaults to mock auth (VITE_MOCK_AUTH=true) so we don't need an
 * Entra app registration to run the app.
 */
import { PublicClientApplication, type Configuration } from '@azure/msal-browser';
import { env } from './env.js';

export const msalConfig: Configuration = {
  auth: {
    clientId: env.ENTRA_CLIENT_ID || '00000000-0000-0000-0000-000000000000',
    authority: `https://login.microsoftonline.com/${env.ENTRA_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // localStorage (not sessionStorage) so the account + tokens survive page
    // refreshes, idle tab discards, and browser restarts. sessionStorage is
    // per-tab and cleared when the browser session ends, which dropped the
    // session on refresh-after-idle ("missing bearer token"). With localStorage,
    // acquireTokenSilent renews the short-lived access token from the cached
    // refresh token, and falls back to a hidden-iframe SSO against the live
    // Entra session — keeping the user signed in for ~a week without re-login.
    cacheLocation: 'localStorage',
    // Mirror auth state into a cookie so silent renewal still works when the
    // browser blocks third-party cookies in the hidden iframe (Safari ITP, etc.).
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: [`${env.API_AUDIENCE}/.default`],
};

export const msalInstance = new PublicClientApplication(msalConfig);

let initialized = false;
export async function ensureMsalInitialized(): Promise<void> {
  if (initialized) return;
  await msalInstance.initialize();
  initialized = true;
}
